import { gql } from '@apollo/client';
import PROVISIONING_RESULT from 'graph/fragments/provisioning-result';

const UNLOCK_ORDER_MASTERCODE = gql`
  mutation unlockOrderMastercodes($orderId: Int!) {
    unlockOrderMastercodes(where: { id: $orderId }) {
      ...BaseProvisioningResultFragment
    }
  }
  ${PROVISIONING_RESULT}
`;

export default UNLOCK_ORDER_MASTERCODE;
